var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseBlack = function SvgCloseBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#14161A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CloseBlack_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "CloseBlack_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 8,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.666 5.332-5.334 5.334M5.332 5.332l5.334 5.334",
    stroke: "#757D8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#CloseBlack_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.666 2.668h10.667v10.667H2.666z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CloseBlack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.666 2.668)",
    d: "M0 0h10.667v10.667H0z"
  })))));
};
export { SvgCloseBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMxNDE2MUEiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQxMjdfMTUzMTM5KSI+CjxtYXNrIGlkPSJtYXNrMF80MTI3XzE1MzEzOSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iNCIgeT0iNCIgd2lkdGg9IjgiIGhlaWdodD0iOCI+CjxwYXRoIGQ9Ik0xMC42NjY0IDUuMzMyMDNMNS4zMzIwMyAxMC42NjY0IiBzdHJva2U9IiM3NTdEOEEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4zMzIwMyA1LjMzMjAzTDEwLjY2NjQgMTAuNjY2NCIgc3Ryb2tlPSIjNzU3RDhBIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzQxMjdfMTUzMTM5KSI+CjxyZWN0IHg9IjIuNjY2MDIiIHk9IjIuNjY3OTciIHdpZHRoPSIxMC42NjY3IiBoZWlnaHQ9IjEwLjY2NjciIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF80MTI3XzE1MzEzOSI+CjxyZWN0IHdpZHRoPSIxMC42NjY3IiBoZWlnaHQ9IjEwLjY2NjciIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjY2NjAyIDIuNjY3OTcpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";